import React from "react";
import * as _ from "lodash";

import { sortGamesByDate } from "../common_page_elements";
import {AUTHOR_NAME, CLUES, CREATED, LAST_PLAYED, PUBLIC, PUBLISHED} from "../../constants/Game";
import { GameListing } from "./GameListing";

/**
 * Component to be used within an admin authenticated page only.
 */
const AllHunts = props => {
   const { authorFilterText,
      onAuthorFilterChange,
      onGameSelect,
      gameMap,
      gameFilter,
      titleTimePeriod } = props;

   const games = gameMap ? _.values(gameMap) : null;

   // Create second filter for showing only hunts by author
   const all = (game) => game[CREATED];
   // const allPublic = (game) => game[PUBLIC];

   const byAuthor = (game) => {
      const gameAuthor = game[AUTHOR_NAME];
      if (!!gameAuthor) {
         return gameAuthor.toLowerCase().indexOf(authorFilterText.toLowerCase()) >= 0
      } else {
         return false;
      }
   };

   // const byIsSample = (game) => game.isSample;
   const filter2 =  authorFilterText && authorFilterText.length > 1
      ? byAuthor
      : all;

   const gamesToShow = !!games ? games.filter(gameFilter).filter(filter2) : null;
   const gameListStats = !!games ? gameStats(gamesToShow) : null;

   return (
      <div>
         <h3 className="HomePage-left-margin-above-bootstrap-list big-bottom-margin big-top-margin">
            Authored Hunts -- {titleTimePeriod}  <small>(Select item to view activity.)</small>
         </h3>

         <div className="big-left-margin"> Filter by Author
            <input className="left-margin" type='text' value={authorFilterText}
                   onChange={onAuthorFilterChange}/>
         </div>

         {gameListStats &&
            <div className="big-left-margin top-margin bottom-margin" >
               Total: <b>{gameListStats.total}, </b>
               Has clues: <b>{gameListStats.hasClues}, </b>
               Played: <b>{gameListStats.isPlayed}, </b>
               Published: <b> {gameListStats.isPublished} </b>
               Public: <b> {gameListStats.isPublic}. </b>
            </div>
         }
         <ul className="list-group home-list-margins">
            {games ?
               <GameListing
                  games={sortGamesByDate( gamesToShow )}
                  onGameSelect={onGameSelect}
                  showAuthor={true}/>
               : "Loading..."}
         </ul>
      </div>
   );
};

function gameStats(games) {
   var total = 0;
   var hasClues = 0;
   var isPlayed = 0;
   var isPublic = 0;
   var privatePublished = 0;
   var publicPublished = 0;
   _.forEach(games, function (game) {
      total++;
      if (!!game[CLUES] && game[CLUES].length > 0) {
         hasClues++;
         if (!!game[LAST_PLAYED]) {
            isPlayed++;
            if (game[PUBLIC]) {
               isPublic++;
               if (game[PUBLISHED]) {
                  publicPublished++;
               }
            } else {
               if (game[PUBLISHED]) {
                  privatePublished++;
               }
            }
         }
      }
   });
   return { total: total, hasClues: hasClues, isPlayed: isPlayed, isPublished: publicPublished+privatePublished, isPublic: isPublic }
}

export default AllHunts;



// WEBPACK FOOTER //
// ./src/components/yourpage/AllHunts.js